export default __webpack_public_path__ + "static/media/add-active.6f8be697.svg";